import { useState } from "react";
import { useNavigate } from "react-router";
import { ListPage } from "@/archetypes/ListPage";
import { DataGrid, type DataGridColumn } from "@/components/data-grid";
import { Button } from "@/components/ui/button";
import { useMfgItems, useMfgItemTypes, type MfgItemRow } from "@/lib/mfg-catalog";

export function MfgCatalogAdminPage() {
  const navigate = useNavigate();
  const [q, setQ] = useState("");
  const [typeCode, setTypeCode] = useState("");
  const [page, setPage] = useState(0);
  const { data: types } = useMfgItemTypes();
  const { data, isLoading } = useMfgItems({
    q,
    itemTypeCode: typeCode || undefined,
    page: page + 1,
    pageSize: 50,
  });

  const cols: DataGridColumn<MfgItemRow>[] = [
    { id: "name", header: "Name", accessor: (r) => r.name },
    { id: "type", header: "Type", accessor: (r) => r.itemTypeCode },
    { id: "number", header: "Item #", accessor: (r) => r.itemNumber ?? "—" },
    { id: "uom", header: "UoM", accessor: (r) => r.unitOfMeasureCode ?? "—" },
  ];

  return (
    <ListPage
      title="Mfg Catalog"
      search={{ value: q, onChange: (v) => { setQ(v); setPage(0); }, placeholder: "Search name / item #…" }}
      filterBar={
        <select
          className="rounded-md border border-input bg-background px-3 py-2 text-sm"
          value={typeCode}
          onChange={(e) => { setTypeCode(e.target.value); setPage(0); }}
          aria-label="Filter by type"
        >
          <option value="">All types</option>
          {(types ?? []).map((t) => (
            <option key={t.mfgItemTypeCode} value={t.mfgItemTypeCode}>{t.name}</option>
          ))}
        </select>
      }
      primaryAction={<Button onClick={() => void navigate("/admin/mfg-catalog/new")}>+ New item</Button>}
    >
      <DataGrid
        rows={data?.rows ?? []}
        columns={cols}
        rowKey={(r) => r.mfgItemId}
        totalRows={data?.total ?? 0}
        pageIndex={page}
        pageSize={50}
        loading={isLoading}
        onPageChange={setPage}
        onRowClick={(r) => void navigate(`/admin/mfg-catalog/${r.mfgItemId}`)}
      />
    </ListPage>
  );
}
